// convert field props from Contentful to props we want for our components

const transformProps = (props, id) => {
  const newObj = {};
  const transformKey = (key) => {
    switch (key) {
      case 'category':
        return id === 'assetList' ? 'sectionName' : key;
      default:
        return key;
    }
  };
  const transformValue = (key, value) => {
    switch (key) {
      case 'imageLinks':
        return value.map(({ image, link, ...rest }) => ({
          image: {
            src: image.file.url,
            title: image.title,
          },
          url: (link.pagePaths && link.pagePaths.length > 0) ? link.pagePaths[0].path : link,
          ...rest,
        }));
      case 'backgroundColor':
        return value ? value.replace(/\s/g, '') : null;
      case 'columns':
        return parseInt(value, 10);
      default:
        return value;
    }
  };
  Object.entries(props).forEach(([key, value]) => {
    newObj[transformKey(key)] = transformValue(key, value);
  });
  return newObj;
};

export default transformProps;
